// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-oasis -> weidner-apartment-homes-oasis-oasis -> lakehaus
// Generated: 2026-11-03T17:58:30.079Z
// Counts: 0 design, 20 content, 20 slot group, 2 collection binding, 9 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactblock.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our high-resolution photo gallery to get a sneak peek at Lakehaus Apartments. Take a look at the various rooms in our actual apartments and notice the elegant touches like open-concept layouts, spacious bathrooms with garden tubs, and in-unit laundry. You can also view some of our community amenities that will expand your living space, like our rooftop pool, work-from-home hub, and luxurious sauna.</p><p>Do you like what you see? Then, we encourage you to view one of our virtual tours or schedule a personal tour to see all that Lakehaus apartments has to offer! Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<h1><strong>Faq</strong></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently Asked Questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Come home to relaxed, elegant living at Lakehaus Apartments. Our apartments in West Lake are in a vibrant area along the Midtown Greenway near the Bde Maka Ska, Calhoun Square, and 50th &amp; France. Lakehaus offers modern apartments with sophisticated amenities in a warm and active community. It’s also pet-friendly, near the west metro, and provides unique condo-style layouts.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourblock.form_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>We'd love to hear from you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=160/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "tourblock.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Lake Haus in vibrant Minneapolis, MN, your ideal living space awaits. Choose from our thoughtfully designed one-bedroom and two-bedroom floor plans, tailored to fit your lifestyle. Each home offers unique features and stunning views, making relaxation effortless. Browse our available apartment homes today and discover your perfect match!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our high-resolution photo gallery to get a sneak peek at Lakehaus Apartments. Take a look at the various rooms in our actual apartments and notice the elegant touches like open-concept layouts, spacious bathrooms with garden tubs, and in-unit laundry. You can also view some of our community amenities that will expand your living space, like our rooftop pool, work-from-home hub, and luxurious sauna.</p><p>Do you like what you see? Then, we encourage you to view one of our virtual tours or schedule a personal tour to see all that Lakehaus apartments has to offer! Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "homeamenities.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Lakehaus offers several amenities to elevate your routines. Outside your door is a rooftop pool, a state-of-the-art fitness center, an on-site dog spa, and a luxurious sauna. You’ll experience immediate comfort in your home with elegant touches like garden tubs, chef-quality kitchens with stainless steel appliances, in-unit laundry, and your personal deck.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Lakehaus is between the beautiful Bde Maka Ska and Cedar Lake, connecting you to the best neighborhoods and amenities that Minneapolis has to offer. Exploring Minneapolis is seamless with several transit options like the Midtown Greenway, west metro, Hwy 7, and the upcoming Southwest Greenline LRT, connecting you to the most dynamic areas in the city. Enjoy fantastic shopping at Calhoun Commons, Linden Hills, or 50th &amp; France retail, or savor delicious cuisine at local hotspots like Agra Culture Kitchen and Nightingale.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourblock.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule your tour of Lakehaus Apartments in Minneapolis, MN, today! When you visit, you’ll be pleased to find 1 and 2-bedroom apartments featuring beautiful balcony views and spacious condo style units. You’ll also love our community's outdoor fire pit and state-of-the-art fitness center .</p><p>To see more of Lakehaus Apartments, view our virtual tours. Or, use the calendar to schedule a live virtual tour or in-person tour, both guided by one of our knowledgeable leasing professionals. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourblock.heading": {
    "overrideType": "VALUE",
    "customValue": "<h1><strong>Find Your Future Home at LakeHaus</strong></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourblock.preheading": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Schedule a Tour</strong></h2>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "floorplanslist.card_image_2": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "propertyoverview.front_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "contactblock.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.youtube_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.youtube.com/user/WeidnerApartments"
      }
    }
  },
  "amenities-hero.collage_image_1": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "amenities-hero.collage_image_2": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "contactblock.hero_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "floor-plans-hero.collage_image_1": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "floor-plans-hero.collage_image_2": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "future-residents-club-hero.collage_image_1": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "future-residents-club-hero.collage_image_2": {
    "sourceIndex": 30,
    "fieldOverrides": null
  },
  "gallery-hero.collage_image_1": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "gallery-hero.collage_image_2": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[32].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[32].image_media.alt_text"
      }
    }
  },
  "neighborhood-hero.collage_image_1": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "neighborhood-hero.collage_image_2": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "tourblock.hero_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "virtual-tour-hero.collage_image_1": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "virtual-tour-hero.collage_image_2": {
    "sourceIndex": 10,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "homeneighborhood.gallery": {
    "limit": null,
    "hiddenIds": [
      "ec_122e1a9b2f22309ab4fba724"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      1
    ],
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery": {
    "limit": null,
    "hiddenIds": [
      "ec_122e1a9b2f22309ab4fba724"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      1
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 10
    }
  ]
};

export const styleOverrides = {};
